<div class="timeline-page-wrap card-bg-white">
  <h1 class="sec-title">Timeline</h1>

  <form class="formwrapper d-flex" *ngIf = "(isPremium || isAdvance) && this.all_data.timeline.length > 0" [formGroup]="timelineForm">
    <div class="input-group">
      <select class="select-type-report form-select" id='tag' name="tag" formControlName=tag>
          <option value="">Select Tag</option>
          <option *ngFor="let event of tag" [value]="event">{{ event }}</option>
      </select>
    </div>
    <div class="input-group">
      <select class="select-type-report form-select" id='year' name="year" formControlName=year>
          <option value="">Select Year</option>
          <option *ngFor="let year of years" [value]="year">{{ year }}</option>
      </select>
    </div>
  </form>


  <div class="wrap-timelines" *ngIf = "(isPremium || isAdvance)">
    <ng-container *ngFor="let year of years">
      <div class="timeline"  *ngIf="groupedTimeline[year]?.length > 0">
        <h5>FY {{ year }}</h5>
        
        <p-timeline [value]="groupedTimeline[year]">
          <ng-template pTemplate="content" let-event>
            <div class="contentwrap">
              <span class="month">{{ getMonth(event.eventDate) }}</span>
              <h6 [ngStyle]="{'background-color': generatePastelColor(event.label)}">{{ event.label }}</h6>
              <!-- <p>{{ event.description }}</p> -->
              <div [innerHTML]="event.description | safeHtml"></div>
            </div>
          </ng-template>
        </p-timeline>
      </div>
    </ng-container>
  </div>

  <div class="wrap-free-graph wrap-funding"  *ngIf="isFree">
  <app-blur-field [product]="productList['TML']" [companyName]="all_data.name"></app-blur-field>
  </div>
</div>